/* =========================================================================
   VV03 — Hombro Vivelia
   JS módulo: pack selector sync + FAQ accordion + pack-bar visibility +
              ATC form submission
   ========================================================================= */
(function () {
  'use strict';

  /* -----------------------------------------------------------------------
     1) PACK SELECTOR SYNC
     Click en cualquier .vv03-pack-card → marca .is-selected en todas las cards
     del mismo data-vv03-pack en TODO el documento (hero + segunda oferta + bar).
     Notifica via CustomEvent 'vv03:pack-change' { qty, variantId, price, compareAt }.
     ----------------------------------------------------------------------- */
  function selectPack(qty, opts) {
    opts = opts || {};
    var cards = document.querySelectorAll('[data-vv03-pack]');
    var chosen = null;
    cards.forEach(function (card) {
      var match = card.getAttribute('data-vv03-pack') === qty;
      card.classList.toggle('is-selected', match);
      if (match && !chosen) chosen = card;
    });
    if (!chosen) return;

    var detail = {
      qty: qty,
      variantId: chosen.getAttribute('data-vv03-variant-id') || '',
      price: parseInt(chosen.getAttribute('data-vv03-price'), 10) || 0,
      compareAt: parseInt(chosen.getAttribute('data-vv03-compare-at'), 10) || 0,
      initial: !!opts.initial
    };
    document.dispatchEvent(new CustomEvent('vv03:pack-change', { detail: detail }));
  }

  function initPackCards() {
    document.querySelectorAll('[data-vv03-pack]').forEach(function (card) {
      card.addEventListener('click', function () {
        selectPack(card.getAttribute('data-vv03-pack'));
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectPack(card.getAttribute('data-vv03-pack'));
        }
      });
    });

    // Determinar el pack inicial:
    //   1) Si el URL trae ?variant=X y matchea una de nuestras pack cards → usar ese
    //   2) Si no, usar el que tenga .is-selected en el server-render (default_pack del schema)
    // En ambos casos emitimos vv03:pack-change con { initial: true } → la galería
    // del hero NO scrollea a la imagen de la variante (se queda en product.images[0]),
    // pero el resto de listeners (precio, sticky, sysval, ahorras) sí sincronizan.
    var initialCard = null;
    try {
      var urlVariant = new URL(window.location.href).searchParams.get('variant');
      if (urlVariant) {
        initialCard = document.querySelector(
          '[data-vv03-pack][data-vv03-variant-id="' + urlVariant + '"]'
        );
      }
    } catch (e) { /* URL API no disponible — ignorar */ }
    if (!initialCard) {
      initialCard = document.querySelector('[data-vv03-pack].is-selected');
    }
    if (initialCard) {
      setTimeout(function () {
        selectPack(initialCard.getAttribute('data-vv03-pack'), { initial: true });
      }, 0);
    }
  }

  /* -----------------------------------------------------------------------
     2) ATC button label + sticky CTA price update
     Listeners actualizan elementos visuales cuando cambia el pack.
     ----------------------------------------------------------------------- */
  function formatMoney(cents) {
    if (!cents) return '';
    var dollars = cents / 100;
    return '$' + dollars.toLocaleString('es-MX', {
      minimumFractionDigits: dollars % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
  }

  function initPackListeners() {
    document.addEventListener('vv03:pack-change', function (e) {
      var d = e.detail;
      var priceFmt = formatMoney(d.price);
      var compareFmt = formatMoney(d.compareAt);
      var saveFmt = formatMoney(d.compareAt - d.price);
      var hasSavings = d.compareAt > d.price;

      // Main CTA label (texto entre los guiones)
      document.querySelectorAll('[data-vv03-cta-price]').forEach(function (el) {
        el.textContent = priceFmt;
      });

      // Variant id input (form submission)
      document.querySelectorAll('[data-vv03-variant-input]').forEach(function (input) {
        input.value = d.variantId;
      });

      // === Hero: precio grande dinámico ===
      document.querySelectorAll('[data-vv03-hero-price]').forEach(function (el) {
        el.textContent = priceFmt;
      });
      // Hero: inline 'Hoy: $X' dentro del sysval
      document.querySelectorAll('[data-vv03-hero-price-inline]').forEach(function (el) {
        el.textContent = priceFmt;
      });
      // Hero: compare_at tachado dentro del sysval
      document.querySelectorAll('[data-vv03-hero-compare]').forEach(function (el) {
        el.textContent = compareFmt;
        el.style.display = hasSavings ? '' : 'none';
      });
      // Hero: pill de ahorro (legacy — sigue funcionando si hay [data-vv03-hero-save])
      document.querySelectorAll('[data-vv03-hero-save]').forEach(function (el) {
        el.textContent = saveFmt;
      });
      document.querySelectorAll('[data-vv03-hero-save-wrap]').forEach(function (el) {
        if (el.hasAttribute('hidden')) el.hidden = !hasSavings;
        else el.style.display = hasSavings ? '' : 'none';
      });

      // Hero: línea de valor por pack (toggle hidden)
      document.querySelectorAll('[data-vv03-sysval]').forEach(function (el) {
        el.hidden = el.getAttribute('data-vv03-sysval') !== d.qty;
      });
      // Hero: pill de ahorro por pack (toggle hidden)
      document.querySelectorAll('[data-vv03-save-pack]').forEach(function (el) {
        el.hidden = el.getAttribute('data-vv03-save-pack') !== d.qty;
      });

      // Sticky CTA (current + compare strikethrough)
      var stickyPrice = document.querySelector('[data-vv03-sticky-price]');
      if (stickyPrice) {
        stickyPrice.innerHTML =
          (hasSavings ? '<span class="vv03-sticky-cta__strike">' + compareFmt + '</span> ' : '') +
          priceFmt;
      }

      // Floating pack-bar price (compact)
      var packBarPrice = document.querySelector('[data-vv03-packbar-price]');
      if (packBarPrice) {
        packBarPrice.textContent = priceFmt;
      }

      // "Mostrando X Pack..." line en hero
      document.querySelectorAll('[data-vv03-showing-line]').forEach(function (el) {
        var s = d.qty !== '1' ? 's' : '';
        el.innerHTML = 'Mostrando: <strong>' + d.qty + ' Pack' + s + '</strong> — cambia la cantidad abajo.';
      });
    });
  }

  /* -----------------------------------------------------------------------
     3) FAQ ACCORDION
     ----------------------------------------------------------------------- */
  function initFAQ() {
    document.querySelectorAll('[data-vv03-faq-q]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-vv03-faq-item]');
        if (item) item.classList.toggle('is-open');
      });
    });
  }

  /* -----------------------------------------------------------------------
     4) FLOATING PACK-BAR VISIBILITY
     Aparece tras scroll past el primer pack selector (hero).
     ----------------------------------------------------------------------- */
  function initPackBar() {
    var bar = document.querySelector('[data-vv03-pack-bar]');
    var anchor = document.querySelector('[data-vv03-hero-offer]');
    if (!bar || !anchor) return;

    function update() {
      var pastAnchor = anchor.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-visible', pastAnchor);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* -----------------------------------------------------------------------
     5) STICKY CTA visibility:
        - oculto mientras el ATC del hero aún está en viewport
        - visible una vez que se baja y sale de pantalla
        - oculto cerca del footer
     ----------------------------------------------------------------------- */
  function initStickyCTA() {
    var sticky = document.querySelector('[data-vv03-sticky-cta]');
    if (!sticky) return;
    var heroAtc = document.querySelector('[data-vv03-hero-offer] [data-vv03-atc-btn]') ||
                  document.querySelector('[data-vv03-hero-offer]');

    // Estado:
    // - heroAtcEverSeen: true cuando el IO ha visto el ATC del hero al menos una vez
    //   (en móvil el ATC suele estar bajo el fold al cargar, así que NO lo damos por
    //   visto hasta que el usuario lo haya tenido en pantalla)
    // - heroAtcVisible: true mientras el ATC del hero esté en viewport
    var heroAtcEverSeen = false;
    var heroAtcVisible = false;

    // Si no hay IO o no hay hero ATC, no podemos rastrear visibilidad real → fallback
    // de 'scroll mínimo + estamos cerca del bottom del hero' es imperfecto, así que
    // en ese caso jamás mostramos sticky para no aparecer en lugares equivocados.
    var canTrack = heroAtc && 'IntersectionObserver' in window;

    function applyVisibility() {
      var scrollY = window.scrollY || window.pageYOffset;
      var docH = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
      var viewH = window.innerHeight;
      var nearFooter = scrollY + viewH > docH - 200;

      var shouldShow;
      if (canTrack) {
        // Solo mostrar cuando el usuario YA vio el ATC del hero y ahora está fuera
        shouldShow = heroAtcEverSeen && !heroAtcVisible && !nearFooter;
      } else {
        // Fallback ultra-conservador: scroll > 600px y no en footer
        shouldShow = scrollY > 600 && !nearFooter;
      }

      sticky.classList.toggle('is-hidden', !shouldShow);
    }

    if (canTrack) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          heroAtcVisible = entry.isIntersecting;
          if (heroAtcVisible) heroAtcEverSeen = true;
          applyVisibility();
        });
      }, { threshold: 0.01, rootMargin: '0px 0px -10% 0px' });
      io.observe(heroAtc);
    }

    window.addEventListener('scroll', applyVisibility, { passive: true });
    window.addEventListener('resize', applyVisibility, { passive: true });
    applyVisibility();
  }

  /* -----------------------------------------------------------------------
     6) ATC FORM SUBMISSION + preconnect to checkout domain
     Cada formulario [data-vv03-atc-form] usa el botón [data-vv03-atc-btn]
     para submit con return_to=/checkout — bypassea drawer de Upcart.
     ----------------------------------------------------------------------- */
  function initATC() {
    document.querySelectorAll('[data-vv03-atc-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var btn = form.querySelector('[data-vv03-atc-btn]');
        if (btn) {
          btn.setAttribute('disabled', 'disabled');
          btn.dataset.originalLabel = btn.innerHTML;
          btn.innerHTML = 'Procesando…';
        }
        // Show overlay for perceived speed
        showCheckoutOverlay();
        // form submits naturally to /cart/add with return_to=/checkout
      });
    });
  }

  function showCheckoutOverlay() {
    var overlay = document.createElement('div');
    overlay.className = 'vv03-checkout-overlay';
    overlay.innerHTML =
      '<div class="vv03-checkout-overlay__spinner"></div>' +
      '<div class="vv03-checkout-overlay__title">Llevándote al checkout…</div>' +
      '<div class="vv03-checkout-overlay__sub">Un segundo, por favor.</div>';
    document.body.appendChild(overlay);
  }


  /* -----------------------------------------------------------------------
     7) STICKY CTA — Add to cart (AJAX) + abrir drawer Upcart (con fallbacks)
     ----------------------------------------------------------------------- */
  function initStickyATC() {
    document.querySelectorAll('[data-vv03-sticky-atc]').forEach(function (btn) {
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        var card = document.querySelector('[data-vv03-pack].is-selected') ||
                   document.querySelector('[data-vv03-pack]');
        if (!card) {
          var anchor = btn.getAttribute('data-vv03-target-anchor');
          if (anchor) window.location.hash = anchor.replace(/^#/, '');
          return;
        }
        var variantId = card.getAttribute('data-vv03-variant-id');
        if (!variantId) {
          var a2 = btn.getAttribute('data-vv03-target-anchor');
          if (a2) window.location.hash = a2.replace(/^#/, '');
          return;
        }

        var originalLabel = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = 'Agregando…';

        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd,
          credentials: 'same-origin'
        })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.json && res.json.description || 'Error al agregar');
          openCartDrawer();
        })
        .catch(function (err) {
          console.error('[VV03] sticky ATC error:', err);
          window.location.href = '/cart';
        })
        .finally(function () {
          btn.disabled = false;
          btn.innerHTML = originalLabel;
        });
      });
    });
  }

  function openCartDrawer() {
    // Dispatch eventos comunes (Upcart, Hulk, Slide Cart, ICart, etc.)
    var events = [
      'upcart:open', 'upcart:cart:open', 'upcart:openCart',
      'cart:open', 'cart:refresh', 'cart:build',
      'dispatch:cart-drawer:open', 'ajaxProduct:added'
    ];
    events.forEach(function (name) {
      try { document.dispatchEvent(new CustomEvent(name, { bubbles: true })); } catch (e) {}
      try { window.dispatchEvent(new CustomEvent(name)); } catch (e) {}
    });

    // Disparar click en triggers conocidos
    var triggerSelectors = [
      '[data-upcart-trigger]',
      'upcart-app',
      '.upcart-button-block',
      '[data-cart-toggle]',
      '[data-drawer-toggle="cart"]',
      'a[href="#cart-drawer"]',
      'a[href="/cart"][data-cart-link]',
      '#cart-icon-bubble',
      '.cart-link'
    ];
    var opened = false;
    triggerSelectors.forEach(function (sel) {
      if (opened) return;
      var el = document.querySelector(sel);
      if (el && typeof el.click === 'function') {
        try { el.click(); opened = true; } catch (e) {}
      }
    });

    // Nota: NO añadimos .js-drawer-open al <html>. Esa clase aplica
    // overflow:hidden en el theme legacy y UpCart no sabe limpiarla al cerrar
    // su drawer → bloqueaba el scroll en móvil después de cerrar.
    // UpCart maneja su propio scroll-lock internamente.

    // Nota: NO redirigimos automáticamente — UpCart ya abre el drawer correctamente
    // tras el AJAX add. Forzar redirect aquí causa el bug de "abre y luego salta a /cart".
  }


  /* -----------------------------------------------------------------------
     8) HEADER CART COUNT — live refresh sin reload de página
        - Intercepta fetch a /cart/add|change|update|clear
        - Escucha eventos comunes (cart:updated, upcart:*, ajaxProduct:added)
        - Refresca al volver al tab (visibilitychange)
     ----------------------------------------------------------------------- */
  function initCartCount() {
    var nodes = document.querySelectorAll('[data-vv03-cart-count]');
    if (!nodes.length) return;

    function paint(count) {
      nodes.forEach(function (el) {
        el.textContent = count;
        if (count > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
    }

    function refresh() {
      fetch('/cart.js', {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') paint(cart.item_count);
      })
      .catch(function () {});
    }

    // 1) Intercept fetch — refresh tras requests a endpoints del cart
    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function () {
        var args = arguments;
        var url = '';
        try {
          url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
        } catch (e) {}
        var p = origFetch.apply(this, args);
        if (/\/cart\/(add|change|update|clear)(\.js|$)/.test(url)) {
          p.then(function () { setTimeout(refresh, 60); }).catch(function () {});
        }
        return p;
      };
    }

    // 2) Intercept XMLHttpRequest — apps viejas + UpCart en algunos modos
    if (window.XMLHttpRequest) {
      var origOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        try {
          if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
            this.addEventListener('loadend', function () { setTimeout(refresh, 60); });
          }
        } catch (e) {}
        return origOpen.apply(this, arguments);
      };
    }

    // 3) Eventos pub/sub comunes
    [
      'cart:updated', 'cart:refresh', 'cart:build', 'cart:change',
      'upcart:cart:updated', 'upcart:cart:open', 'upcart:cart:close',
      'ajaxProduct:added', 'product:added'
    ].forEach(function (name) {
      document.addEventListener(name, function () { setTimeout(refresh, 60); });
      window.addEventListener(name, function () { setTimeout(refresh, 60); });
    });

    // 4) Visibility change → al volver al tab
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') refresh();
    });

    // 5) Sync inicial por si el server-rendered estaba stale (back-navigation)
    refresh();
  }

  /* -----------------------------------------------------------------------
     INIT
     ----------------------------------------------------------------------- */
  function init() {
    // Safety: limpiar clases drawer-open colgadas del theme legacy
    // (si un sticky ATC previo las dejó pegadas y bloqueando scroll).
    document.documentElement.classList.remove(
      'js-drawer-open', 'js-drawer-open-right', 'js-drawer-open-left'
    );

    initPackCards();
    initPackListeners();
    initFAQ();
    initPackBar();
    initStickyCTA();
    initATC();
    initStickyATC();
    initGallery();
    initCartCount();
  }

  /* -----------------------------------------------------------------------
     7) HERO GALLERY: thumbs click → swap main image
        Plus variant sync: on pack change, swap to variant.featured_image if set
     ----------------------------------------------------------------------- */
  function initGallery() {
    // Variant → image_id map (rendered as JSON inline)
    var variantImagesMap = {};
    var jsonEl = document.querySelector('[data-vv03-variant-images]');
    if (jsonEl) {
      try { variantImagesMap = JSON.parse(jsonEl.textContent); }
      catch (e) { variantImagesMap = {}; }
    }

    var slider = document.querySelector('[data-vv03-slider]');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-vv03-thumb]'));
    var slides = slider ? Array.prototype.slice.call(slider.querySelectorAll('[data-vv03-slide-index]')) : [];

    /* ====================================================
       Helpers compartidos
       ==================================================== */
    function setActiveThumbIndex(index) {
      thumbs.forEach(function (t) {
        var idx = parseInt(t.getAttribute('data-vv03-thumb'), 10);
        t.classList.toggle('is-active', idx === index);
      });
    }

    function scrollToSlideIndex(index, behavior) {
      if (!slider || !slides[index]) return;
      var slide = slides[index];
      slider.scrollTo({
        left: slide.offsetLeft - slider.offsetLeft,
        behavior: behavior || 'smooth'
      });
    }

    function findSlideIndexByImageId(imageId) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-vv03-image-id') === String(imageId)) {
          return i;
        }
      }
      return -1;
    }

    /* ====================================================
       MODO SLIDER (cuando hay producto con múltiples imágenes)
       ==================================================== */
    if (slider && slides.length > 0) {
      // 1) Thumb click → scrollTo del slide
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var idx = parseInt(btn.getAttribute('data-vv03-thumb'), 10);
          if (isNaN(idx)) return;
          scrollToSlideIndex(idx, 'smooth');
          // Active state se setea via IntersectionObserver al detectar el slide visible
        });
      });

      // 2) IntersectionObserver: detecta slide visible al swipe/scroll → sync thumb active
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
              var idx = parseInt(entry.target.getAttribute('data-vv03-slide-index'), 10);
              if (!isNaN(idx)) setActiveThumbIndex(idx);
            }
          });
        }, { root: slider, threshold: [0.55] });
        slides.forEach(function (s) { io.observe(s); });
      } else {
        // Fallback sin IntersectionObserver
        slider.addEventListener('scroll', function () {
          var sliderRect = slider.getBoundingClientRect();
          for (var i = 0; i < slides.length; i++) {
            var r = slides[i].getBoundingClientRect();
            if (r.left >= sliderRect.left - 5 && r.left < sliderRect.left + sliderRect.width / 2) {
              setActiveThumbIndex(i);
              break;
            }
          }
        }, { passive: true });
      }

      // 3) Variant sync: pack change → busca image_id correspondiente, scrollea
      //    En la emisión inicial NO scrolleamos: queremos que la galería se quede
      //    en la primera imagen del producto (product.images[0]), no en la de la
      //    variante default. Los clicks reales del usuario sí scrollean.
      document.addEventListener('vv03:pack-change', function (e) {
        if (e.detail && e.detail.initial) return;
        var vid = e.detail.variantId;
        if (!vid) return;
        var imageId = variantImagesMap[vid];
        if (!imageId) return;
        var idx = findSlideIndexByImageId(imageId);
        if (idx >= 0) scrollToSlideIndex(idx, 'smooth');
      });

      // 4) Keyboard navigation (←/→) cuando el slider está focused/hover
      slider.setAttribute('tabindex', '0');
      slider.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var current = -1;
        thumbs.forEach(function (t) {
          if (t.classList.contains('is-active')) {
            current = parseInt(t.getAttribute('data-vv03-thumb'), 10);
          }
        });
        if (current < 0) current = 0;
        var next = e.key === 'ArrowRight' ? Math.min(current + 1, slides.length - 1) : Math.max(current - 1, 0);
        if (next !== current) scrollToSlideIndex(next, 'smooth');
      });

      return; // No ejecutar el modo single-image
    }

    /* ====================================================
       MODO SINGLE-IMAGE (override hero_image, sin slider)
       ==================================================== */
    function swapHeroImage(src, srcset) {
      var slot = document.querySelector('[data-vv03-gallery-slot]');
      if (!slot) return;
      slot.src = src;
      if (srcset) slot.srcset = srcset;
      else slot.removeAttribute('srcset');
    }

    // Thumb click (modo single-image legacy) — los thumbs pueden tener data-vv03-img-src
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var src = btn.getAttribute('data-vv03-img-src');
        var srcset = btn.getAttribute('data-vv03-img-srcset');
        if (src) swapHeroImage(src, srcset);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });

    // Variant sync (modo single-image): swap directo del src si la URL está en el map
    // (skip en initial — la imagen renderizada server-side ya es la correcta)
    document.addEventListener('vv03:pack-change', function (e) {
      if (e.detail && e.detail.initial) return;
      var vid = e.detail.variantId;
      if (!vid) return;
      var val = variantImagesMap[vid];
      if (val && typeof val === 'string' && val.indexOf('http') === 0) {
        swapHeroImage(val, null);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
